'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        backgroundColor: variables.COLORS.WHITE,
        color: variables.COLORS.GREYSCALE_25,
    },
};

var MuiSnackbarContent = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiSnackbarContent = MuiSnackbarContent;
exports.light = light;
